<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 1.33337V3.33337M10.6667 1.33337V3.33337M2.33333 6.06004H13.6667M14 5.66671V11.3334C14 13.3334 13 14.6667 10.6667 14.6667H5.33333C3 14.6667 2 13.3334 2 11.3334V5.66671C2 3.66671 3 2.33337 5.33333 2.33337H10.6667C13 2.33337 14 3.66671 14 5.66671Z"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path
      d="M7.99663 9.1333H8.0033M5.5293 9.1333H5.53596M5.5293 11.1333H5.53596"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
